"use client";

import { useState, FC, useEffect } from "react";
import styles from "./detailed-features.module.scss";
import { IVDPBlockData, IVDPPageBlock, VDPBlockPosition } from "../../../types/vdp";
import { getTranslationModule } from "../../../utils/translations";

import VDPSection from "@/ui/page-components/vehicle-details-page/vdp-section";
import VDPButton from "@/ui/page-components/vehicle-details-page/button";
import { useIsMobile } from "@/utils/useIsMobile";
import useAnalytics from "@/analytics/useAnalytics";

const MOBILE_ELEMENTS_COUNT = 16;
const DESKTOP_ELEMENTS_COUNT = 28;

const DetailedFeatures: FC<IVDPPageBlock> = ({ vdpGlobalData, pageContext, translations }) => {
  const { sendAnalyticsEvent } = useAnalytics();
  const isMobile = useIsMobile(1280, pageContext.isSmartphone);
  const t = getTranslationModule(translations, "vdp");
  // const [currentTab, setCurrentTab] = useState("Interior");
  const [detailedFeaturesLength, setDetailedFeaturesLength] = useState<number>();
  const [showAllFeatures, setShowAllfeatures] = useState<boolean>(true);
  const showMoreButtonText = showAllFeatures ? t("show_more") : t("show_less");
  const showMoreButtonTitle = showAllFeatures ? "show more" : "show less";
  const vehicle = vdpGlobalData.vehicle;

  const showButtonHandler = () => {
    sendAnalyticsEvent("asc_cta_interaction", {
      element_text: showMoreButtonText,
      element_type: "item_details",
      event_action_result: showAllFeatures ? "increase" : "decrease",
      element_title: showMoreButtonTitle,
      link_url: "",
    });
    if (showAllFeatures) {
      setDetailedFeaturesLength(vehicle?.features?.length || 0);
    } else {
      setDetailedFeaturesLength(isMobile ? MOBILE_ELEMENTS_COUNT : DESKTOP_ELEMENTS_COUNT);
    }
    setShowAllfeatures(!showAllFeatures);
  };

  useEffect(() => {
    setDetailedFeaturesLength(isMobile ? MOBILE_ELEMENTS_COUNT : DESKTOP_ELEMENTS_COUNT);
  }, [isMobile]);

  return (
    <VDPSection title={t("features")} subtitle={`${vehicle.make} ${vehicle.model} ${vehicle.trim}`}>
      <div className={styles.container}>
        {/* <Tabs
        className={styles.tabs}
        items={[
            "Interior",
            "Extarior",
            "Safety",
            "Features",
            "Entertainment",
        ]}
        currentTab={currentTab}
        setCurrentTab={setCurrentTab}
        type={"big"}
        /> */}
        <div className={styles.content}>
          {vehicle?.features?.slice(0, detailedFeaturesLength).map((item, index) => (
            <div className={styles.itemContainer} key={index}>
              {isMobile && <span className={styles.itemDot}></span>}
              <span className={styles.item}>{item}</span>
            </div>
          ))}
        </div>
        <VDPButton
          name={"detailedFeaturesExpandButton"}
          className={styles.button}
          onClick={showButtonHandler}
          title={showMoreButtonText}
          isMobile={pageContext.isSmartphone}
        />
      </div>
    </VDPSection>
  );
};

const VDPBlockData: IVDPBlockData = {
  component: (props: IVDPPageBlock, key: any) => (
    <DetailedFeatures
      key={key}
      config={props.config}
      siteData={props.siteData}
      pageContext={props.pageContext}
      renderingPosition={props.renderingPosition}
      vdpGlobalData={props.vdpGlobalData}
      translations={props.translations}
    />
  ),
  position: VDPBlockPosition.LEFT,
};

export default VDPBlockData;
